
import { Component, Prop, Vue } from 'vue-property-decorator'
import InputAnswerText from '@/components/molecules/InputAnswerText.vue'
import KatexMixedText from '@/components/molecules/KatexMixedText.vue'
import ButtonInput from '@/components/organisms/study/ButtonInput.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * 択一式入力イベント発生時の処理型
 */
export type InputSingleChoiceFunction = (
  question: StudyModel.Question,
  afterFunction: StudyModel.AfterInputSingleChoiceFunction
) => void

/**
 * 設問情報の解答欄表示(択一式)
 */
@Component({
  components: {
    InputAnswerText,
    KatexMixedText,
    ButtonInput,
  },
})
export default class InputSingleChoice extends Vue {
  /** 設問情報 */
  @Prop()
  private question!: StudyModel.Question

  /** 入力時の処理 */
  @Prop()
  private inputSingleChoice!: InputSingleChoiceFunction

  /** アクティブな入力欄のインデックス(0固定) */
  private activeIndex: number = 0

  /** 入力値の更新タイムスタンプ(DOMを更新させるために使う) */
  private updatedAt: number = 0

  /**
   * 表示用要素の取得
   *
   * @returns 入力式の表示用要素
   */
  private get item(): StudyModel.FrontValueSingleChoice {
    return this.question.contents[this.activeIndex].frontValues as StudyModel.FrontValueSingleChoice
  }

  /**
   * 入力イベント
   */
  private input(): void {
    this.inputSingleChoice(this.question, this.afterFunction)
  }

  /**
   * 入力後の処理
   *
   * @param value 入力された値
   */
  private afterFunction(value: string): void {
    // 値の更新
    this.question.inputValues[this.activeIndex] = value
    // DOM更新のためキー値を書き換え
    this.updatedAt = new Date().valueOf()
  }
}
